export const CONTACT_EMAIL = 'info@residentieleo.be';
